import type { Authen, LoginRequest, UserProfile } from './type';

export const defaultLoginRequest: LoginRequest = {
  account: '',
  password: '',
};

export const defaultAuthen: Authen = {
  token: '',
};

export const defaultUserProfile: UserProfile = {
  email: '',
  id: '',
  gender: '',
  nickname: '',
  name: '',
  role: {
    id: '',
    key: '',
    name: '',
  },
  institution: {
    id: '',
    name: '',
    isActive: false,
    code: '',
    email: '',
  },
  permission: {
    webs: [],
  },
};

export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_#^()+=~`{}|/:;'"<>[,.-])[A-Za-z\d@$!%*?&_#^()+=~`{}|/:;'"<>[,.-]{8,}$/;
